<div *ngIf="!isProd" class="region-banner" fxLayout="column" fxLayoutAlign="center start">
  <div class="region-banner-content" fxLayout="row" fxLayoutAlign="center center">
    <span class="region-banner__non-prod">Non-Prod</span>
    <span *ngIf="showRegion" class="region-banner__region">{{ region }}</span>
  </div>
</div>
